<template>
  <div
    v-if="isDragging"
    class="flex h-8 w-full flex-col justify-center rounded-sm border-2 border-dashed border-gray-300 text-center text-xxs uppercase"
    :class="highlightDropZone ? 'bg-blue-100' : 'bg-blue-100/50'"
    @dragover="highlightDropZone = true"
    @dragleave="highlightDropZone = false"
  >
    <div
      data-cy="drop-attribute-zone"
      class="h-8 w-full leading-7"
      @drop="dropRole"
      @dragover.prevent
    >
      {{ placeholder }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits<{
  "role:drop": [DragEvent];
}>();

defineProps({
  isDragging: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "",
  },
});
const highlightDropZone = ref(false);
const dropRole = (event: DragEvent) => {
  emit("role:drop", event);
};
</script>
